import { Routes } from '@angular/router';
import { BrandsService } from '@app/leasing-company/data-mapping/brands/services/brands.service';
import { ModelsService } from '@app/leasing-company/data-mapping/models/services/models.service';
import { ModelOptionsService } from '@app/leasing-company/data-mapping/models/services/model-options.service';

export const dataMappingRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/leasing-company/data-mapping/data-mapping.component').then(component => component.DataMappingComponent),
    providers: [
      BrandsService,
      ModelsService,
    ],
    children: [
      {
        path: 'brands',
        loadComponent: () => import('@app/leasing-company/data-mapping/brands/brands.component').then(component => component.BrandsComponent),
      },
      {
        path: 'models',
        loadComponent: () => import('@app/leasing-company/data-mapping/models/models.component').then(component => component.ModelsComponent),
        providers: [ModelOptionsService,],
      },
      {
        path: '**',
        redirectTo: 'brands',
      },
    ],
  },
];
